var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "application-layout",
    {
      key: _vm.refresh,
      attrs: { "show-sidebar": _vm.showSidebar },
      on: { "toggle-sidebar": _vm.toggleSidebar },
      scopedSlots: _vm._u([
        {
          key: "sidebar",
          fn: function () {
            return [
              _c("full-application-sidebar", {
                attrs: { "application-id": _vm.applicationId },
                on: { refresh: _vm.handleRefreshPage },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "topbar",
          fn: function (ref) {
            var showSidebar = ref.showSidebar
            return [
              _c("locked-application-banner"),
              _vm._v(" "),
              _c("application-navbar", {
                attrs: {
                  "current-step": _vm.currentStep,
                  "invalid-steps": _vm.invalidSteps,
                  "show-sidebar": showSidebar,
                },
                on: {
                  "toggle-sidebar": _vm.toggleSidebar,
                  "navigate-next": _vm.goNext,
                  "navigate-back": _vm.goPrev,
                  "navigate-edit": _vm.goEdit,
                },
              }),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c("application-quick-actions", {
        attrs: { "with-confirmation": false },
      }),
      _vm._v(" "),
      _c("application-standalone", {
        ref: "applicationStandalone",
        attrs: {
          "application-id": _vm.applicationId,
          "current-step": _vm.currentStep,
          "invalid-steps": _vm.invalidSteps,
        },
        on: {
          "update:currentStep": function ($event) {
            _vm.currentStep = $event
          },
          "update:current-step": function ($event) {
            _vm.currentStep = $event
          },
          "invalid-step": _vm.handleInvalidStep,
          submitted: _vm.handleApplicationSubmitted,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }